<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="商品信息" name="first">
                <ProduceInfo></ProduceInfo>
            </el-tab-pane>
            <el-tab-pane label="商品新增" name="second">
                <ProduceAdd></ProduceAdd>
            </el-tab-pane>
            <!-- <el-tab-pane label="定时任务" name="third">-->
            <!--    <ProduceTimingTask></ProduceTimingTask>-->
            <!--</el-tab-pane>-->
        </el-tabs>
    </div>
</template>

<script>
import ProduceAdd from './ProduceAdd.vue';
import ProduceInfo from './ProduceInfo.vue';
import ProduceTimingTask from './ProduceTimingTask.vue';

export default {
    name: 'ProduceControl',
    components: {
        ProduceAdd,
        ProduceInfo,
        ProduceTimingTask
    },
    data: function(){
        return {
            activeName: 'first'
        }
    },
    created() {
    
    },
    methods: {
        handleClick(tab, event) {
        
        }
    }
}
</script>

<style scoped lang="scss">
    .handle-input {
        width: 260px;
        display: inline-block;
        margin-right: 10px;
    }
</style>
